<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Registro Usuario
                  <v-spacer></v-spacer>
                  <v-btn rounded dark color="primary" @click="clear(true)">Nuevo</v-btn>
                  <ModalUsuarioComponent :open="obModal.open" :listGeneral="listGeneral" :parametros="parametros" :obModal="obModal" />
            </v-card-title>
            <v-container fluid grid-list-sm>
                  <v-row dense>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Tipo Usuario *" color="textbox" :items="listGeneral.listTipoUsuario"
                                    v-model='obSearch.idTipoUsuario' item-value="idTipoUsuario" item-text="tipoUsuario"
                                    outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Estado *" color="textbox" :items="listGeneral.listEstado"
                                    item-text="nombre_estado" item-value="id_estado" v-model='obSearch.idEstado'
                                    outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                          <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                :disabled="disabled">
                                                <v-icon dark>search</v-icon>
                                          </v-btn>
                                    </template>
                                    <span>Buscar</span>
                              </v-tooltip>
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12" sm="6" />
                        <v-col cols="12" sm="6">
                              <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                                    prepend-inner-icon="search" />
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12">
                              <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"
                                    :items="listGeneral.detalle" class="elevation-3">

                                    <template v-slot:item.name="{ item }">
                                          <v-btn class="ma-2" text icon color="primary" @click="editItem(item)">
                                                <v-icon small>edit</v-icon>
                                          </v-btn>
                                    </template>

                                    <template v-slot:no-results>
                                          Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                                    </template>
                              </v-data-table>
                        </v-col>
                  </v-row>
            </v-container>
      </v-card>
</template>

<script>
      export default {
            name: 'UsuarioView',
            components:{
                  ModalUsuarioComponent: () => import('@/components/seguridad/ModalUsuarioComponent.vue') 
            },
            data: () => ({
                  obSearch: {
                        search: '',
                        idTipoUsuario: null,
                        idEstado: null
                  },
                  obModal: {
                        open: false,
                        titulo: '',
                        usuario:'',
                        nombres:'',
                        apellidos:'',
                        idPerfil:null,
                        idTipoUsuario:null,
                        idCliente:null,
                        idAseguradora:null,
                        idEstado:null
                  },
                  listGeneral: {},
                  parametros: {},
                  disabled:false
            }),
            created() {
                  var error = 'E';
                  this.disabled = true;
                  axios.post(`${BASE_URI}administrador/usuario/cargaGeneral`)
                        .then((r) => {
                              if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                              if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    this.$set(this, 'listGeneral', r.data.data.listas);
                                    this.$set(this, 'parametros', r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    this.obSearch.idTipoUsuario = _.get(this.listGeneral,['listTipoUsuario','1','idTipoUsuario'],null);
                                    this.disabled = false;
                                    this.onListar('L');
                        })
                        .catch((e) => {
                              this.disabled = false;
                              mensajesAlerta(e, error);
                        })
            },
            methods: {
                  clear(band) {
                        this.obModal = {
                              open: band,
                              titulo: 'Nuevo Usuario',
                              usuario:'',
                              nombres:'',
                              apellidos:'',
                              idPerfil:null,
                              idTipoUsuario:null,
                              idCliente:null,
                              idAseguradora:null,
                              idEstado: _.toString(this.parametros.id_estado_default)
                        }
                  },
                  onListar(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              var o = {
                                    opcion:'LISTAR_DETALLE',
                                    idTipoUsuario:_.toNumber(this.obSearch.idTipoUsuario) == 0 ? null : this.obSearch.idTipoUsuario,
                                    idEstado:_.toNumber(this.obSearch.idEstado) == 0 ? null : this.obSearch.idEstado
                              }
                              
                              this.disabled = true;
                              this.listGeneral.detalle = [];
                              axios.post(`${BASE_URI}administrador/usuario/listarDetalle`,o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                                this.listGeneral.detalle = r.data.data;
                                                this.disabled = false;
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                          this.disabled = false;
                                    });
                        }
                  },
                  editItem(v){
                        this.obModal = _.merge({},this.obModal,v,{titulo:'Editar Usuario',open:true,idCliente:v.idCLiente});
                  },
                  submit(){
                        var error = 'E';
                        this.obModal.idCLiente = _.size(this.obModal.idCliente) > 0 ? _.get(this.obModal,'idCliente',null) : this.obModal.idCLiente;
                        console.info(this.obModal)
                        var keys = [
                                          'idUsuario','usuario','nombres','apellidos','idPerfil',
                                          'idTipoUsuario','idCLiente','idAseguradora','idEstado',
                                          'idUsuarioPerfil','idUsuarioAseguradora','idUsuarioCliente'
                                    ];

                        var o = _.merge({opcion:_.size(this.obModal.idUsuario) == 0 ? 'I' : 'U'},_.pick(this.obModal,keys));

                        axios.post(`${BASE_URI}administrador/usuario/registroUsuario`,o)
                              .then((r)=>{
                                    if (_.get(r, ['data', 'existeError'], true)) { 
                                          var x = "Registro Existente.";
                                          var m = _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                          throw _.toUpper(m).includes(_.toUpper(x)) ? x : m;
                                    };

                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                          mensajeAlertaTiempo(r.data.mensaje,'S');
                                          this.disabled = false;
                                          this.clear(false);
                                          this.onListar('L');
                              })
                              .catch((e) => {
                                    mensajesAlerta(e, error);
                                    this.disabled = false;
                              });
                  }
            },
            provide(){
                  return{
                        close:this.clear,
                        submit:this.submit
                  }
            }
      }
</script>